import { Form, Formik } from "formik";
import { useState } from "react";
import { InvoiceCustomerAddressComponents } from "components/InvoiceCustomerModal/InvoiceCustomerAddressComponent";
import { CustomerAddress } from "types/Models/invoice";

export const CustomerAddressRow = ({
  customerId,
  customerName,
  groupId,
  entityId,
  onAddressSelect,
}: {
  customerId: string;
  customerName: string;
  groupId: string;
  entityId: string;
  onAddressSelect: (
    customerId: string,
    address: CustomerAddress | null
  ) => void;
}) => {
  const [selectedAddressId, setSelectedAddressId] = useState<string>();

  const handleAddressSelect = (address: CustomerAddress | null) => {
    setSelectedAddressId(address?.uuid);
    onAddressSelect(customerId, address);
  };

  return (
    <div className="t-grid t-grid-cols-2 t-gap-4 t-items-start t-py-3 t-border-0 t-border-b t-border-solid t-border-neutral-0">
      <p className="t-m-0 t-text-body-sm t-text-text-100 t-pt-2">
        {customerName}
      </p>
      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <InvoiceCustomerAddressComponents
            groupId={groupId}
            entityId={entityId}
            customerId={customerId}
            addressType="BILLING"
            label=""
            selectedAddressId={selectedAddressId}
            onAddressSelect={handleAddressSelect}
            hideClear
          />
        </Form>
      </Formik>
    </div>
  );
};
